import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import layout from '@/views/layout/index.vue'
const routes = [
  {
    path: '/',//根目录路由为/
    redirect: '/home',//重定向至/home页面
    component: layout,
    children: [
      {//子菜单信息
        path: '/home',//路径
        name: 'home',
        component: () => import('@/views/home/index.vue'),//指定组件
        meta: { title: '首页', icon: 'el-icon-location' }
      },
      {//子菜单信息
        path: '/digital',//路径
        name: 'digital',
        component: () => import('@/views/digital/index.vue'),//指定组件
        meta: { title: '我的形象', icon: 'el-icon-location' }
      },
      {//子菜单信息
        path: '/audio',//路径
        name: 'audio',
        component: () => import('@/views/audio/index.vue'),//指定组件
        meta: { title: '声音克隆', icon: 'el-icon-location' }
      },
      {//子菜单信息
        path: '/works',//路径
        name: 'works',
        component: () => import('@/views/works/index.vue'),//指定组件
        meta: { title: '声音克隆', icon: 'el-icon-location' }
      },
      {//子菜单信息
        path: '/user',//路径
        name: 'user',
        component: () => import('@/views/user/index.vue'),//指定组件
        meta: { title: '声音克隆', icon: 'el-icon-location' }
      },
      {//子菜单信息
        path: '/text',//路径
        name: 'text',
        component: () => import('@/views/works/text.vue'),//指定组件
        meta: { title: '声音克隆', icon: 'el-icon-location' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
